import React from 'react';
import { Paper } from '@mantine/core';
import { FileDown, Download } from 'lucide-react';
import { EButton } from 'libs/ui';

interface IPayloadCardProps {
    type: 'request' | 'response';
    mediaId: number;
    fileName: string;
    isDownloading: boolean;
    onDownload: (mediaId: number, fileName: string) => void;
}

export const PayloadCard: React.FC<IPayloadCardProps> = ({
    type,
    mediaId,
    fileName,
    isDownloading,
    onDownload
}) => {
    const isRequest = type === 'request';
    const colorScheme = isRequest ? 'blue' : 'green';
    const gradientFrom = isRequest ? 'from-blue-50' : 'from-green-50';
    const gradientTo = isRequest ? 'to-blue-100/50' : 'to-green-100/50';
    const borderColor = isRequest ? 'border-blue-200' : 'border-green-200';
    const hoverBorderColor = isRequest ? 'hover:border-blue-300' : 'hover:border-green-300';
    const bgColor = isRequest ? 'bg-blue-600' : 'bg-green-600';
    const textColor = isRequest ? 'text-blue-900' : 'text-green-900';
    const label = isRequest ? 'Request Payload' : 'Response Payload';

    return (
        <Paper
            p="md"
            withBorder
            radius="md"
            className={`bg-gradient-to-br ${gradientFrom} ${gradientTo} ${borderColor} ${hoverBorderColor} transition-colors`}
        >
            <div className="flex items-center gap-2 mb-3">
                <div className={`p-1.5 ${bgColor} rounded`}>
                    <FileDown size={14} className="text-white" />
                </div>
                <span className={`text-sm font-semibold ${textColor}`}>
                    {label}
                </span>
            </div>
            <EButton
                size="sm"
                variant="filled"
                color={colorScheme}
                fullWidth
                loading={isDownloading}
                onClick={() => onDownload(mediaId, fileName)}
                leftSection={<Download size={16} />}
                className="font-medium"
            >
                Download
            </EButton>
        </Paper>
    );
};
